import React from 'react';
import PremiumKit from '../../../../assets/images/Campaign/Colour/premium-kit.png';
import { ColourTheme } from '../../../../types/ColourTheme';
import { themeOrder, UnlockStatus, personaToPage, storyLockStatus } from '../../../../constants';
import i18n from 'i18next';
import './PersonaRecommend.scss';
import { StoreContext } from '../../../../store/StoreContext';
import { SupportedLanguage } from '../../../../types/SupportedLanguage';
import { stylize } from '../../../../newHelpers/stylize';

type Props = {
  theme: ColourTheme;
};

export const PersonaRecommend = (props: Props) => {
  const mobileLeft = [themeOrder[0], themeOrder[2], themeOrder[4], themeOrder[6]];
  const mobileRight = [themeOrder[1], themeOrder[3], themeOrder[5], themeOrder[7]];
  return (
    <div className="PersonaRecommend">
      <div className="kit-rec">
        <div className="img-container">
          <img src={PremiumKit} alt="kit" />
        </div>
        <div className="text-container">
          <h2>{stylize(i18n.t(`${props.theme}Landing.bigQuote.p.0`))}</h2>
          <h2>{stylize(i18n.t(`${props.theme}Landing.bigQuote.p.1`))}</h2>
          <p>{i18n.t(`${props.theme}Landing.product.p`)}</p>
          <div>
            <button onClick={() => window.open(`https://circledna.com/`, '_blank')}>{i18n.t(`${props.theme}Landing.product.cta`)}</button>
          </div>
          <p className="fineprint">{i18n.t('')}</p>
        </div>
      </div>
      <div className="persona-rec">
        {themeOrder.map((block, index) =>
          <StoreContext.Consumer>
            {
              store =>
                <div
                  className={`container ${props.theme === block ? 'active' : 'hoverable'}`}
                  style={{ width: `calc(100%/${themeOrder.length})`, left: `calc(0% + ((100%/${themeOrder.length}) * ${index}))`}}
                  onClick={() => storyLockStatus[block] === UnlockStatus.unlocked && window.open(`/${store.currentLanguage === SupportedLanguage.Traditional_Chinese ? 'zh-hant/' : store.currentLanguage === SupportedLanguage.Simplified_Chinese ? 'zh-hans/' : ''}${personaToPage[block]}`, '_self')}
                >
                  <div className={`imgBg ${block}`} />
                  <div className="overlay" style={{ width: `calc(100%/${themeOrder.length})`, left: `calc(0% + ((100%/${themeOrder.length}) * ${index}))` }}>
                    <p>{i18n.t(`colourCircle.menuPopup.${block}`)}</p>
                  </div>
                </div>
            }
          </StoreContext.Consumer>
        )}
        {mobileLeft.map((block, index) =>
          <StoreContext.Consumer>
            {
              store =>
                <div
                  className={`mobile-container ${props.theme === block ? 'active' : 'hoverable'} left-row`}
                  style={{ height: `calc(100%/${themeOrder.length / 2})`, top: `calc(0% + ((100%/${themeOrder.length / 2}) * ${index}))`}}
                  onClick={() => storyLockStatus[block] === UnlockStatus.unlocked && window.open(`/${store.currentLanguage === SupportedLanguage.Traditional_Chinese ? 'zh-hant/' : store.currentLanguage === SupportedLanguage.Simplified_Chinese ? 'zh-hans/' : ''}${personaToPage[block]}`, '_self')}
                >
                  <div className={`imgBg ${block}`} />
                  <div className="overlay">
                    <p>{i18n.t(`colourCircle.menuPopup.${block}`)}</p>
                  </div>
                </div>
            }
          </StoreContext.Consumer>
        )}
        {mobileRight.map((block, index) =>
          <StoreContext.Consumer>
            {
              store =>
                <div
                  className={`mobile-container ${props.theme === block ? 'active' : 'hoverable'} right-row`}
                  style={{ height: `calc(100%/${themeOrder.length / 2})`, top: `calc(0% + ((100%/${themeOrder.length / 2}) * ${index}))`}}
                  onClick={() => storyLockStatus[block] === UnlockStatus.unlocked && window.open(`/${store.currentLanguage === SupportedLanguage.Traditional_Chinese ? 'zh-hant/' : store.currentLanguage === SupportedLanguage.Simplified_Chinese ? 'zh-hans/' : ''}${personaToPage[block]}`, '_self')}
                >
                  <div className={`imgBg ${block}`} />
                  <div className="overlay">
                    <p>{i18n.t(`colourCircle.menuPopup.${block}`)}</p>
                  </div>
                </div>
            }
          </StoreContext.Consumer>
        )}
      </div>
    </div>
  );
};